import React from 'react';
import FooterDrawer from '@/components/ui/atoms/FooterDrawer';
import MInputField from '@/components/ui/atoms/MInputField';
import styles from './document.module.css';
import { IconX } from '@tabler/icons-react';

function formatFileSize(bytes?: number): string {
  if (!bytes || isNaN(bytes)) return '-';
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

function formatDate(date?: string): string {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString();
}

interface DocumentInfoDrawerProps {
  open: boolean;
  onClose: () => void;
  fileName: string;
  size?: number;
  uploadedAt?: string;
}

const DocumentInfoDrawer: React.FC<DocumentInfoDrawerProps> = ({ open, onClose, fileName, size, uploadedAt }) => {
  return (
    <FooterDrawer open={open} onClose={onClose} title="Document details">
      <div className={styles.infoContentFlex}>
        <MInputField
          label="File Name"
          value={fileName}
          variant="Underlined"
          size="md"
          readOnly
        />
        <MInputField
          label="File Size"
          value={formatFileSize(size)}
          variant="Underlined"
          size="md"
          readOnly
        />
        <MInputField
          label="Date Uploaded"
          value={formatDate(uploadedAt)}
          variant="Underlined"
          size="md"
          readOnly
        />
      </div>
    </FooterDrawer>
  );
};

export default DocumentInfoDrawer;
